<template lang="pug">
v-menu(v-if="loggedIn")
  template(v-slot:activator="{ on }")
    v-btn(text v-on="on")
     v-avatar(color="secondary" size="32")
        v-icon(dark small) mdi-account
  v-list
    v-list-item
      v-list-item-avatar(color="secondary")
        v-icon(dark) mdi-account
      v-list-item-title {{ userName }}
    v-list-item(@click="logout()")
      v-list-item-title Sign Out
    v-list-item(@click="revokeAccessAndLogout()")
      v-tooltip(left)
        | Removes the permission you granted to Papartisan upon sign-in. No data will be lost.
        template(v-slot:activator="{ on }")
          v-list-item-title(v-on="on") Revoke Google Access &amp; Sign Out
</template>
<script>
  import { mapGetters, mapActions } from 'vuex'
  export default {
    data() {
      return {
        avatarError: false
      }
    },
    computed: {
      ...mapGetters([
        'loggedIn',
        'userName',
        'userAvatar'
      ]),
    },
    methods: {
      ...mapActions(["logout", "revokeAccessAndLogout"]),
    }
  }
</script>